import { IThemeInfo } from 'scheme/themeInfo';
import styled from 'styled-components/macro';
import { theme } from 'styles/theme';
import Bubble from 'assets/images/img_bubble_big.png';
import TopTextBubbleImage from 'assets/images/bubble/bubble_before_open_top.png';
import TopTextBubbleImageEng from 'assets/images/bubble/bubble_before_open_top_eng.png';
import BottomTextBubbleImage from 'assets/images/bubble/bubble_before_open_bottom.png';
import BottomTextBubbleImageEng from 'assets/images/bubble/bubble_before_open_bottom_eng.png';
import QuestionBoxImage from 'assets/images/img_question_box.png';
import { t } from 'i18next';
import i18n from 'i18n';
import { LanguageType } from 'scheme/languageType';
import { useSendToApp } from 'hooks/useSendToApp';
import { event } from 'react-ga';
import { parseLanguageType } from 'utils/parseLanguageType';

interface ISingleThemeBubbleProps {
  isOpen: boolean;
  themeInfo: IThemeInfo;
  handleBeforeOpenedClick: () => void;
}

interface IThemeName {
  isLong: boolean;
}

export default function DoubleThemeBubble({ isOpen, themeInfo, handleBeforeOpenedClick }: ISingleThemeBubbleProps) {
  const { sendToApp } = useSendToApp();

  const handleThemeClick = (themeId: string, themeUrl: string) => {
    event({
      category: 'click_theme',
      action: 'Click theme',
      label: themeId,
    });

    try {
      return sendToApp('event', `theme/${themeId}`);
    } catch (err) {}
    window.location.href = themeUrl;
  };

  return (
    <BubbleContainer>
      <BubbleImage src={Bubble} />
      {isOpen ? (
        <>
          {parseLanguageType(i18n.language) === LanguageType.KO ? (
            <>
              <TopTextBubble src={themeInfo.afterOpenTopBubble} />
              <BottomTextBubble src={themeInfo.afterOpenBottomBubble} />
            </>
          ) : (
            <>
              <TopTextBubble src={themeInfo.afterOpenTopBubbleEng} />
              <BottomTextBubble src={themeInfo.afterOpenBottomBubbleEng} />
            </>
          )}
          <ThemeTitle>{t(themeInfo.afterOpenTitle)}</ThemeTitle>
          <ThemeImageContainer>
            <ThemeImage
              src={themeInfo.themes[0].previewImageUrl}
              onClick={() => {
                handleThemeClick(themeInfo.themes[0].themeId, themeInfo.themes[0].themeUrl);
              }}
            />
            <ThemeNameBlank></ThemeNameBlank>
            <ThemeImage
              src={themeInfo.themes[1].previewImageUrl}
              onClick={() => {
                handleThemeClick(themeInfo.themes[1].themeId, themeInfo.themes[1].themeUrl);
              }}
            />
            <ThemeNameBlank></ThemeNameBlank>
          </ThemeImageContainer>
          <TopThemeName
            isLong={t(themeInfo.themes[0].afterOpenThemeName).length > 20}
            onClick={() => {
              handleThemeClick(themeInfo.themes[0].themeId, themeInfo.themes[0].themeUrl);
            }}
          >
            <ThemeNameText>{t(themeInfo.themes[0].afterOpenThemeName)}</ThemeNameText>
          </TopThemeName>
          <BottomThemeName
            isLong={t(themeInfo.themes[1].afterOpenThemeName).length > 20}
            onClick={() => {
              handleThemeClick(themeInfo.themes[1].themeId, themeInfo.themes[1].themeUrl);
            }}
          >
            <ThemeNameText>{t(themeInfo.themes[1].afterOpenThemeName)}</ThemeNameText>
          </BottomThemeName>
        </>
      ) : (
        <>
          {parseLanguageType(i18n.language) === LanguageType.KO ? (
            <>
              <TopTextBubble src={TopTextBubbleImage} />
              <BottomTextBubble src={BottomTextBubbleImage} />
            </>
          ) : (
            <>
              <TopTextBubble src={TopTextBubbleImageEng} />
              <BottomTextBubble src={BottomTextBubbleImageEng} />
            </>
          )}
          <ThemeTitle>{t(themeInfo.beforeOpenTitle)}</ThemeTitle>
          <ThemeImageContainer>
            <ClosedThemeImage src={QuestionBoxImage} onClick={handleBeforeOpenedClick} />
            <ThemeNameBlank></ThemeNameBlank>
            <TopCharacterImage src={themeInfo.themes[0].characterImage[0]} />
            <ClosedThemeImage src={QuestionBoxImage} onClick={handleBeforeOpenedClick} />
            <ThemeNameBlank></ThemeNameBlank>
            <BottomCharacterImage src={themeInfo.themes[1].characterImage[0]} />
          </ThemeImageContainer>
          <TopThemeName isLong={t(themeInfo.themes[0].beforeOpenThemeName).length > 20}>
            <ThemeNameText onClick={handleBeforeOpenedClick}>
              {t(themeInfo.themes[0].beforeOpenThemeName)}
            </ThemeNameText>
          </TopThemeName>
          <BottomThemeName isLong={t(themeInfo.themes[1].beforeOpenThemeName).length > 20}>
            <ThemeNameText onClick={handleBeforeOpenedClick}>
              {t(themeInfo.themes[1].beforeOpenThemeName)}
            </ThemeNameText>
          </BottomThemeName>
        </>
      )}
    </BubbleContainer>
  );
}

const BubbleContainer = styled.div`
  position: relative;
  padding: 1rem 0;
`;

const BubbleImage = styled.img``;

const TopTextBubble = styled.img`
  width: 60%;
  position: absolute;
  top: 0%;
  right: 0%;
  z-index: 100;
`;

const ThemeTitle = styled.div`
  position: absolute;
  top: 12%;
  right: 50%;
  text-align: center;
  font-weight: 900;
  color: ${theme.color.titleTextColor};
  line-height: 14px;
  font-size: 1.8rem;
  width: 100%;
  transform: translate(50%, 0);
  @media screen and ${theme.device.mobile} {
    font-size: 1.4rem;
  }
  @media screen and ${theme.device.mobileMini} {
    font-size: 1.5rem;
  }
`;

const ThemeImageContainer = styled.div`
  position: absolute;
  top: 55%;
  right: 50%;
  transform: translate(50%, -50%);
  width: 50%;
`;

const ThemeImage = styled.img`
  border-radius: 8px;
  cursor: pointer;
  -webkit-box-shadow: 0px 0px 15px -4px #fca294;
  box-shadow: 0px 0px 15px -4px #fca294;
`;

const ClosedThemeImage = styled.img`
  border-radius: 8px;
  -webkit-box-shadow: 0px 0px 15px -4px #fca294;
  box-shadow: 0px 0px 15px -4px #fca294;
  cursor: pointer;
`;

const ThemeNameBlank = styled.div`
  margin: 23% 0;
`;

const TopThemeName = styled.div<IThemeName>`
  ${({ isLong }) =>
    isLong &&
    `
  font-size: 1.3rem !important;
  `}
  text-align: center;
  color: ${theme.color.titleTextColor};
  line-height: 14px;
  font-size: 1.4rem;
  width: 100%;
  position: absolute;
  top: 49%;
`;

const BottomThemeName = styled.div<IThemeName>`
  ${({ isLong }) =>
    isLong &&
    `
  font-size: 1.3rem !important;
  `}
  text-align: center;
  color: ${theme.color.titleTextColor};
  line-height: 14px;
  font-size: 1.4rem;
  width: 100%;
  position: absolute;
  @media screen and ${theme.device.mobile} {
    bottom: 11%;
  }
  @media screen and ${theme.device.mobileMini} {
    bottom: 10%;
  }
  bottom: 12%;
`;

const ThemeNameText = styled.div`
  cursor: pointer;
  display: inline-block;
  font-weight: 400;
`;

const BottomTextBubble = styled.img`
  width: 60%;
  position: absolute;
  bottom: 0%;
  left: 5%;
  z-index: 100;
`;

const TopCharacterImage = styled.img`
  width: 8.5rem;
  @media screen and ${theme.device.mobile} {
    width: 6.5rem;
  }
  @media screen and ${theme.device.mobileMini} {
    width: 6.5rem;
  }
  position: absolute;
  top: 26%;
  right: 5%;
  z-index: 100;
  transform: translate(60%, -50%);
`;

const BottomCharacterImage = styled.img`
  width: 8.5rem;
  @media screen and ${theme.device.mobile} {
    width: 6.5rem;
  }
  @media screen and ${theme.device.mobileMini} {
    width: 6.5rem;
  }
  position: absolute;
  bottom: 13%;
  left: 0%;
  z-index: 100;
  transform: translate(-50%, 0%);
`;
